module.exports = __webpack_public_path__ + "img/hovered-layer6.031d9956.png";